
import axios from 'axios';
import {API_URL} from "../config/globalConfig";

// 创建一个带有默认配置的 Axios 实例
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // 确保请求都携带凭证
});

export default axiosInstance;
